(function () {
  var debounceTimer;
  var observedRoots = typeof WeakSet === 'function' ? new WeakSet() : null;

  function parseMoneyCents(el) {
    var text = el ? el.textContent.replace(/[^0-9.]/g, '') : '';
    return Math.round(parseFloat(text) * 100) || 0;
  }

  function formatSavings(cents) {
    var dollars = cents / 100;
    return '$' + (dollars % 1 === 0 ? dollars.toFixed(0) : dollars.toFixed(2));
  }

  function queryShadowAll(root, selector) {
    var results = [];
    if (!root) return results;
    try {
      root.querySelectorAll(selector).forEach(function (el) {
        results.push(el);
      });
      root.querySelectorAll('*').forEach(function (el) {
        if (el.shadowRoot) {
          observeRoot(el.shadowRoot);
          queryShadowAll(el.shadowRoot, selector).forEach(function (r) {
            results.push(r);
          });
        }
      });
    } catch (e) {}
    return results;
  }

  function updateSavingsCallouts() {
    var sheet = document.getElementById('CartSheet');
    if (!sheet || sheet.getAttribute('data-state') !== 'open') {
      return;
    }

    queryShadowAll(sheet, '.text-right.whitespace-nowrap').forEach(function (container) {
      var originalEl = container.querySelector('[part="money"]:not([part~="discount"])');
      var discountEl = container.querySelector('[part~="discount"]');
      var savingEl = container.querySelector('.text-xs.text-right');
      if (!originalEl || !discountEl || !savingEl) return;

      var savedCents = parseMoneyCents(originalEl) - parseMoneyCents(discountEl);
      if (savedCents > 0) {
        var next = 'Saving ' + formatSavings(savedCents);
        if (savingEl.textContent !== next) savingEl.textContent = next;
      }
    });
  }

  function scheduleUpdate() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(updateSavingsCallouts, 200);
  }

  function observeRoot(root) {
    if (!root || (observedRoots && observedRoots.has(root))) return;
    if (observedRoots) observedRoots.add(root);
    var obs = new MutationObserver(scheduleUpdate);
    obs.observe(root, { childList: true, subtree: true });
  }

  function init() {
    var root = document.getElementById('recharge-storefront-experiences');
    if (!root) return;

    var sheet = document.getElementById('CartSheet');
    if (sheet) {
      observeRoot(sheet);
      return;
    }

    var boot = new MutationObserver(function () {
      var cartSheet = document.getElementById('CartSheet');
      if (cartSheet) {
        observeRoot(cartSheet);
        boot.disconnect();
      }
    });
    boot.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
